import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DevicesCard } from "@/components/devices/devices-card";
import { Page } from "@/components/page";
import { useMe } from "@/lib/session";

export const Route = createFileRoute("/_app/settings/devices")({
  component: DevicesPage,
});

function DevicesPage() {
  const { t } = useTranslation();
  const me = useMe();
  return (
    <Page title={t("nav.devices")} width="narrow">
      <DevicesCard email={me.email} publicUrl={me.publicUrl} />
    </Page>
  );
}
